import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {createCustomer} from "../API/api";

export const postCustomer = createAsyncThunk(
    "customers/createCustomer",
    async (customer, { rejectWithValue }) => {
        try {
            const response = await createCustomer(customer);
            return response.data;

        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const customersSlice = createSlice({
    name: "customers",
    initialState: {
        postCustomer: {
            status: 'idle',
            error: null
        }
    },
    reducers: { },
    extraReducers: (builder) => {
        builder
            // Create Customer
            .addCase(postCustomer.pending, (state) => {
                state.postCustomer.status = 'loading';
            })
            .addCase(postCustomer.fulfilled, (state) => {
                state.postCustomer.status = 'succeeded';
            })
            .addCase(postCustomer.rejected, (state, action) => {
                state.postCustomer.status = 'failed';
                state.postCustomer.error = action.error.message;
            })
    }});
export default customersSlice.reducer;